export default __webpack_public_path__ + "static/media/wwr-bg.3dd8a84b.webp";